import { useI18next } from 'gatsby-plugin-react-i18next'

export const useI18nString = (): string => {
  const { language } = useI18next()
  switch (language) {
    case 'en':
      return 'enUs'
    case 'ko':
      return 'koKr'
    case 'cn':
      return 'zhCn'
    case 'tw':
      return 'zhTw'
    default:
      return 'jaJp'
  }
}
